<script lang="ts">
	// import logoPercipiobio from "@assets/images/percipiobio.png";
	import logoASI from "@assets/images/asi-logo.webp?w=146&imagetools";
	import logoAxore from "@assets/images/axore-logo.webp?w=180&imagetools";
	import logoCytotest from "@assets/images/cytotest-logo.png?w=180&imagetools";
	import logoEuroclone from "@assets/images/euroclone-logo.png?w=180&imagetools";
	import logoLeica from "@assets/images/leica-logo.png?w=180&imagetools";
	import logoQuandx from "@assets/images/quandx-logo.png?w=180&imagetools";
	import Formatted from "./common/Formatted.svelte";
	import Media from "./common/Media.svelte";
</script>

<section class="grid-container full-width bg-gradient-to-t from-light/50 to-light lg:pt-20 pb-10 pt-12 lg:pb-16">
	<h2 class="text-center max-w-xl mx-auto mb-6 max-lg:text-xl">
		<Formatted text="clb[[Spolupracujeme]] s renomovanými výrobci" />
	</h2>
	<p class="max-w-xl text-center mx-auto leading-relaxed lg:leading-6">
		<Formatted
			text="Ve spolupráci s firmou EuroClone, Leica Biosystems a CytoTest pořádáme workshopy a školení. V oblasti cytogenetiky a molekulární biologie poskytujeme odbornou podporu při zpracování a kultivaci biologického materiálu.Specializujeme se také na metodu fluorescenční in situ hybridizace (FISH), která umožňuje přesnou detekci a analýzu genetických změn. Naším cílem je nabídnout spolehlivé řešení a kvalitní výsledky pro výzkum i diagnostickou praxi."
		/>
	</p>
	<div class="max-lg:full-width">
		<div
			class="md:flex grid grid-cols-3 md:flex-row max-lg:pb-4 default: items-center justify-center gap-2 md:gap-14 mt-4 max-lg:bg-white"
		>
			<a href="https://axore.com/" target="_blank" rel="noopener noreferrer">
				<Media class="px-3 py-1" source={{ src: logoAxore, type: "image/png" }} width={160} height={160} alt="Logo"
				></Media>
			</a>
			<a href="https://quandx.com/" target="_blank" rel="noopener noreferrer">
				<Media class="px-3 py-1" source={{ src: logoQuandx, type: "image/png" }} width={158.24} height={36} alt="Logo"
				></Media>
			</a>
			<a href="https://www.leicabiosystems.com/" target="_blank" rel="noopener noreferrer">
				<Media class="px-3 py-1" source={{ src: logoLeica, type: "image/png" }} width={128.41} height={79} alt="Logo"
				></Media>
			</a>
			<a href="https://www.euroclonegroup.it/" target="_blank" rel="noopener noreferrer">
				<Media class="px-3 py-1" source={{ src: logoEuroclone, type: "image/png" }} width={176} height={88} alt="Logo"
				></Media>
			</a>
			<a href="https://www.cytotest.com/index.asp" target="_blank" rel="noopener noreferrer">
				<Media class="px-3 py-1" source={{ src: logoCytotest, type: "image/png" }} width={167.56} height={76} alt="Logo"
				></Media>
			</a>
			<a href="https://spectral-imaging.com/" target="_blank" rel="noopener noreferrer">
				<Media class="px-3 py-1" source={{ src: logoASI, type: "image/webp" }} width={115.15} height={60} alt="Logo"
				></Media>
			</a>
		</div>
	</div>
</section>
